import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { ProfilePicture } from "../../player-profile/ProfilePicture";
import { Icon } from "../icon/Icon";
import { IdIcon } from "../icon/IdIcon";
import { ResourceIcon } from "../icon/ResourceIcon";
import { NumberFormat } from "../number-format/NumberFormat";
export var RewardItems = function (_a) {
    var items = _a.items;
    if (!items) {
        return React.createElement(React.Fragment, null);
    }
    var IconContainerStyle = IdStyles.IconAmountContainerReward + " h100 flex flex--guts flex--stacked";
    var renderedItems = items.reduce(function (acc, currentValue, index) {
        if (index > 0) {
            acc.push(React.createElement(Icon, { icon: IdIcon.PlusResearchIcn, styleId: IdStyles.IconExtraLarge }));
        }
        if (currentValue.profilePicture !== undefined &&
            currentValue.profilePicture.src !== undefined) {
            var srcString = currentValue.profilePicture.src;
            acc.push(React.createElement(ProfilePicture, { key: currentValue.profilePicture.id, profilePictureName: srcString, profilePictureClassName: "profile_image", profilePictureSize: IdStyles.ProfilePictureLarge }));
        }
        else if (currentValue.resource !== undefined) {
            acc.push(React.createElement("div", { className: IconContainerStyle, key: index },
                React.createElement(ResourceIcon, { resource: currentValue.resource, styleId: IdStyles.IconExtraLarge }),
                currentValue.amount && (React.createElement(NumberFormat, { className: IdStyles.TextBoldAccent, amount: currentValue.amount }))));
        }
        return acc;
    }, []);
    return React.createElement("div", { className: "flex flex--around flex--guts w100" }, renderedItems);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/items-displayer/RewardItems.tsx
// module id = 966
// module chunks = 3